<template>
    <div class="interior-design-slider-large">
        <client-only>
            <slick
            ref="designForwardSlider"
            :options="sliderOptions"
            class="slick-for"
            >
                <div 
                v-for="(slide, i) in largeSlides" 
                class="w-100" 
                :key="i"
                >
                    <nuxt-img provider="static" format="webp"
                        :src="slide.img"
                        :alt="slide.alt"
                        class="d-block w-100 h-auto"
                        width="1920"
                        height="1107"
                        sizes="xs:100vw sm:100vw lg:1920px"
                    />
                </div>
            </slick>
            <div class="slider-arrows position-relative d-flex justify-content-center">

            </div>
        </client-only>
    </div>
</template>

<script>
export default {
    props: ['largeSlides'],
    data() {
        return {
            
            sliderOptions: {
                slidesToShow: 1,
                arrows: true,
                dots: false,
                infinite: true,
                vertical: false,
                lazyLoad: 'ondemand',
                verticalSwiping: false,
                asNavFor: null,
                autoplay: false,
                fade: false,
                centerMode: true,
                centerPadding: '100px',
                autoplaySpeed: 6500,
                adaptiveHeight: false,
                appendArrows: '.slider-arrows',
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                        }
                    }
                ]
            }, 
        }
    }
}
</script>

<style lang="scss">
.interior-design-slider-large {

    .slick-list {
        margin: 0 -10px;
    }

    .slick-slide {
        margin: 0 10px;
    }

    .slick-next, .slick-prev {
        top: 0;
        z-index: 999;
        height: 50px;
        width: 40px;
        display: none;

        @media screen and (max-width: 991px) {
            display: block !important;
        }

        &::before {
            font-family: "slick";
            font-size: 22px;
            line-height: 1;
            color: transparent !important;
            opacity: 1;
            -webkit-font-smoothing: antialiased;
        }
    }

    .slick-prev {
        top: 60px;
        left: 100px;
        width: 50px;
        height: auto;
        // background: #000;
        background-image: url('/img/arrow-left.png');
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;

        @media screen and (max-width: 991px) {
            top: 15px;
        }

        &:hover {
            // background-image: url('/img/design-forward-arrow-left.svg');
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
        }
    }

    .slick-next {
        top: 60px;
        right: 100px;
        width: 50px;
        height: auto;
        // background: #000;
        background-image: url('/img/arrow-right.png');
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;

        @media screen and (max-width: 991px) {
            top: 15px;
        }

        &:hover {
            // background-image: url('/img/design-forward-arrow-right.svg');
            background-position: center;
            background-size: contain;
            background-repeat: no-repeat;
        }
    }
    
}
</style>